import http from '../../http-common';

class EmergencyContactService {
	getAll() {
		return http.get('/users/participant/emergencyContact/');
	}
	create(data) {
		return http.post('/users/participant/emergencyContact/create/', data);
	}
	update(data) {
		return http.put('/users/participant/emergencyContact/update/', data);
	}
	delete(id) {
		return http.delete('/users/participant/emergencyContact/delete/' + id);
	}
}

export default new EmergencyContactService();
